<div class="pos-relative m-t-30 full-grow-no-shrink-no-basis">
  <div class="keno-grid-container">
    <particle-virtual-grid [sourceKey]="sourceType"
                           (valueChanged)="onGridCellValueChange($event)"
                           [invalidateSubject]="invalidateSubject"
    >
    </particle-virtual-grid>
  </div>
</div>
